export default "__VITE_ASSET__BAdzFFpf__"